import { render, staticRenderFns } from "./BookAppearanceV2.vue?vue&type=template&id=2eaf2a1a"
import script from "./BookAppearanceV2.vue?vue&type=script&lang=js"
export * from "./BookAppearanceV2.vue?vue&type=script&lang=js"
import style0 from "./BookAppearanceV2.vue?vue&type=style&index=0&id=2eaf2a1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports